import React from 'react';
import './voucher.scss';
const VoucherTemplate = ({ data }) => {
    var _a, _b, _c, _d;
    const entityName = data.vendor_name || data.contractor_name || data.customer_name || 'N/A';
    const entityLabel = data.vendor_name
        ? 'Vendor Name'
        : data.contractor_name
            ? 'Contractor Name'
            : data.customer_name
                ? 'Customer Name'
                : 'Name';
    const documentNumber = data.voucher_number || data.voucher_no || data.receipt_number || 'N/A';
    const documentDate = data.vendor_voucher_dt || data.contract_voucher_dt || data.date || 'N/A';
    const paymentMode = data.payment_mode || data.payment_mode_descr || 'N/A';
    const accountValue = data.account_number || data.acc_name || 'N/A';
    const accountLabel = data.account_number ? 'Account Number' : 'Account Name';
    const transactionDetail = data.transaction_detail || 'N/A';
    const notes = data.notes || 'N/A';
    const amountValue = Number((_d = (_c = (_b = (_a = data.amount_paid) !== null && _a !== void 0 ? _a : data.total_amount) !== null && _b !== void 0 ? _b : data.total) !== null && _c !== void 0 ? _c : data.amount) !== null && _d !== void 0 ? _d : 0);
    const formattedAmount = amountValue.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return (React.createElement("div", { className: "voucher-page" },
        React.createElement("div", { className: "voucher-header" },
            React.createElement("img", { src: "/images/header.png", className: "voucher-header-image", alt: "" })),
        React.createElement("div", { className: "voucher-content-box" },
            React.createElement("img", { src: "/images/watermark.png", className: "voucher-watermark", alt: "" }),
            React.createElement("div", { className: "voucher-content" },
                React.createElement("div", { className: "voucher-section" },
                    React.createElement("div", { className: "voucher-section-title" }, "VOUCHER DETAILS"),
                    React.createElement("div", { className: "voucher-detail-grid" },
                        React.createElement("div", { className: "voucher-detail-column" },
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" }, "Voucher No:"),
                                React.createElement("span", { className: "detail-value" }, documentNumber)),
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" }, "Date:"),
                                React.createElement("span", { className: "detail-value" }, documentDate)),
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" }, "Payment Mode:"),
                                React.createElement("span", { className: "detail-value" }, paymentMode))),
                        React.createElement("div", { className: "voucher-detail-column" },
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" },
                                    entityLabel,
                                    ":"),
                                React.createElement("span", { className: "detail-value" }, entityName)),
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" },
                                    accountLabel,
                                    ":"),
                                React.createElement("span", { className: "detail-value" }, accountValue)),
                            React.createElement("div", { className: "voucher-detail-row" },
                                React.createElement("span", { className: "detail-label" }, "Transaction Detail:"),
                                React.createElement("span", { className: "detail-value" }, transactionDetail)))),
                    React.createElement("div", { className: "voucher-notes-row" },
                        React.createElement("span", { className: "detail-label" }, "Notes:"),
                        React.createElement("span", { className: "detail-value" }, notes))),
                React.createElement("div", { className: "voucher-section voucher-amount-section" },
                    React.createElement("div", { className: "voucher-section-title" }, "PAYMENT DETAILS"),
                    React.createElement("div", { className: "voucher-amount-row" },
                        React.createElement("span", { className: "detail-label" }, "Amount Paid:"),
                        React.createElement("span", { className: "voucher-amount-value" }, formattedAmount)),
                    React.createElement("div", { className: "voucher-amount-words" },
                        React.createElement("span", { className: "detail-label" }, "Amount in Words:"),
                        React.createElement("span", { className: "detail-value" }, data.amount_in_words || 'N/A'))))),
        React.createElement("img", { src: "/images/footer.png", className: "voucher-footer-image", alt: "" })));
};
export default VoucherTemplate;
